function initHidePriceScript() {
  console.log('Init hide price script');
  
  // Watch for search input changes
  setTimeout(function() {
    const searchInputs = document.querySelectorAll('input[type="search"], input[name="q"]');
    
    searchInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        // Run multiple times with increasing delays to catch Boost results
        setTimeout(hidePricesForTaggedProducts, 300);
        setTimeout(hidePricesForTaggedProducts, 600);
        setTimeout(hidePricesForTaggedProducts, 1000);
        setTimeout(hidePricesForTaggedProducts, 1500);
      });
    });
    
    // Also set up mutation observer
    const searchContainer = document.querySelector('.boost-sd__suggestion-queries');
    if (searchContainer) {
      const observer = new MutationObserver(function() {
        setTimeout(hidePricesForTaggedProducts, 100);
        setTimeout(hidePricesForTaggedProducts, 300);
      });
      observer.observe(searchContainer, { childList: true, subtree: true });
    }
  }, 1000);
}

function hidePricesForTaggedProducts() {
  const productItems = document.querySelectorAll('.boost-sd__suggestion-queries-item--product');
  
  if (productItems.length === 0) {
    return; // No products yet, skip
  }
  
  console.log('Checking', productItems.length, 'products');
  
  productItems.forEach(function(item) {
    // Skip if already processed
    if (item.dataset.priceChecked) {
      return;
    }
    item.dataset.priceChecked = 'true';
    
    const link = item.querySelector('a');
    if (link) {
      const href = link.getAttribute('href');
      const handle = href.split('/products/')[1].split('?')[0].replace(/\/$/, '');
      
      fetch('/products/' + handle + '.js')
        .then(response => response.json())
        .then(product => {
          console.log('Checked:', product.title, '| Has hide-price?', product.tags.includes('hide-price'));
          
          if (product.tags && product.tags.includes('hide-price')) {
            console.log('✓ HIDING PRICE for:', product.title);
            const priceElement = item.querySelector('.boost-sd__suggestion-queries-item-price');
            if (priceElement) {
              priceElement.style.display = 'none';
            }
          }
        })
        .catch(error => console.error('Error:', error));
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHidePriceScript);
} else {
  initHidePriceScript();
}
